import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/assets/policies/duplicate/$id')({
  beforeLoad: () => getTitleContextSlice('Duplicate'),
  staticData: {
    owner: CodeOwner.Assets,
  },
});
